export const JS_COMPONENT: unique symbol = Symbol();

export const PY_COMPONENT: unique symbol = Symbol();
